import { genderIdentityOptions } from 'constants/'
import { ContactType } from 'typings'

export interface PersonalData {
    name?: string
    socialName?: string
    cpf?: string
    birthDate?: string
    term?: boolean
    accountExists?: boolean
    genderIdentity?: genderIdentityOptions | string
    biologicalSex?: string
    anonymousPatient?: boolean
}

export interface Password {
    password?: string
    confirmPassword: string
}

export interface PostalCode {
    postalCode: string
}

export interface PhoneNumber {
    cellphone?: string
    id?: number
}

export interface ContactData {
    id?: number
    value?: string
}

export interface Contact {
    email?: ContactData
    cellphone?: ContactData
    contactType?: ContactType
}

export interface PatientInfoInput {
    name?: string
    socialName?: string
    birthDate?: string
    biologicalSex?: string
    genderIdentity?: string
    cellphone?: string
    cpf?: string
    email?: string
    password?: string
    zipCode?: string
    term?: boolean
    anonymousPatient?: boolean
}
export interface ConfirmTokenData {
    confirmToken: {
        message: string
        authentication: {
            access_token: string
            refresh_token: string
        }
    }
}

export interface ResendTokenData {
    cpf: string
    password: string
    cellphone: string
}

export interface UserName {
    username: string
}

export interface PatientInfoSearch {
    viewerSearch: {
        id: number
        phone: string
        biologicalSex: string
        cep: string
        phoneContacts: Array<PhoneContact>
        emailContacts: Array<EmailContact>
    }
}

export interface PhoneContact {
    id: number
    contactType: string
    value: string
}

export interface EmailContact {
    id: number
    value: string
}

export interface PatientLogin {
    password?: string
    contactId?: number
    cpf?: string
    biologicalSex?: string
    cep?: string
}

export interface SignUpState {
    id?: number
    personalData?: PersonalData
    biologicalSex?: string
    genderIdentity?: genderIdentityOptions | string
    passwords?: Password
    postalCodeNumber?: PostalCode
    contact?: Contact
    phoneContacts?: Array<PhoneContact> | undefined
    emailContacts?: Array<EmailContact> | undefined
}

export interface ViewerSearchResponse {
    id: number
    phone: string
    biologicalSex: string
    cep: string
    phoneContacts: Array<PhoneContact>
    emailContacts: Array<EmailContact>
}

export enum ContactTypes {
    MOBILE = 'MOBILE',
    EMAIL = 'EMAIL',
    WHATSAPP = 'WHATSAPP',
}

export enum ContactLoginStatus {
    CONTACTLINKED = 'CONTACTLINKED',
    CONTACTNOTLINKED = 'CONTACTNOTLINKED',
}

export interface ValidateLoginContactResponse {
    validateLoginContact: {
        status: ContactLoginStatus
    }
}

export interface CheckPatientFederalRevenueResponse {
    checkPatientFederalRevenue: {
        name: string
        birthDate: string
        situation: string
    }
}
